module.exports = __webpack_public_path__ + "static/media/regulament.b52c439a.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/regulament.pdf
// module id = 92
// module chunks = 0